module.exports = __webpack_public_path__ + "img/search-result-no-data.40c77b1d.svg";